'use client'
import { useState, useEffect } from 'react'

export default function LiveCoverageSection({ fallback = {} }) {
  const [data, setData] = useState(fallback)
  useEffect(() => {
    fetch('/api/live-stats').then(r => r.json()).then(setData).catch(() => {})
  }, [])

  const { euroCount, interCount, minEuroPrice, bestEuroDiscount, avgInterSaving, bestEuroSaving, bestInterSaving } = data

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="bg-white rounded-2xl border border-blue-100 p-5 text-center shadow-sm">
        <p className="text-2xl mb-1">🇪🇺</p>
        <p className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-2">European deals</p>
        <p className="text-2xl font-extrabold text-gray-900">{euroCount != null ? euroCount : '—'}</p>
        <p className="text-xs text-gray-500 mt-0.5">live deals</p>
        {minEuroPrice != null && (
          <p className="mt-2 text-sm font-semibold text-blue-700">from €{Math.round(minEuroPrice)} roundtrip</p>
        )}
        {bestEuroDiscount != null && (
          <p className="mt-1 text-xs text-green-600 font-medium">up to {bestEuroDiscount}% off</p>
        )}
        <p className="mt-2 text-xs text-gray-400">Free & Plus plans</p>
      </div>
      <div className="bg-white rounded-2xl border border-indigo-200 p-5 text-center shadow-sm relative">
        {interCount === 0 && (
          <span className="absolute top-2 right-2 text-[10px] font-bold text-amber-600 bg-amber-50 border border-amber-200 px-2 py-0.5 rounded-full">Building…</span>
        )}
        <p className="text-2xl mb-1">🌍</p>
        <p className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-2">Intercontinental</p>
        <p className="text-2xl font-extrabold text-gray-900">{interCount != null ? interCount : '—'}</p>
        <p className="text-xs text-gray-500 mt-0.5">live deals</p>
        {avgInterSaving != null && (
          <p className="mt-2 text-sm font-semibold text-indigo-700">avg €{avgInterSaving} saving</p>
        )}
        {bestInterSaving != null && bestInterSaving > 100 && (
          <p className="mt-1 text-xs text-green-600 font-medium">best: €{bestInterSaving} saved</p>
        )}
        <p className="mt-2 text-xs text-gray-400">Pro plan</p>
      </div>
    </div>
  )
}
